const toolTips = () => {

  const toolTipsList = document.querySelectorAll(".tooltip");
  let container = document.querySelector(".container__contact-method--email");

  return {
    toggleToolTips: _ => {
      if (toolTipsList.length) {
        toolTipsList.forEach(tooltip => {
          tooltip.addEventListener("mouseover", e => {
            if (window.matchMedia("(min-width: 1025px)").matches) {
              e.preventDefault();
              if (!tooltip.classList.contains("open")) {
                tooltip.classList.add("open");
                if (container) {
                  container.classList.add("tooltip_opened");
                }
              }
            }
          });
          tooltip.addEventListener("mouseout", e => {
            if (window.matchMedia("(min-width: 1025px)").matches) {
              e.preventDefault();
              if (tooltip.classList.contains("open")) {
                tooltip.classList.remove("open");
                if (container) {
                  container.classList.remove("tooltip_opened");
                }
              }
            }
          });
          tooltip.addEventListener("click", e => {
            if (window.matchMedia("(max-width: 1024px)").matches) {
              const tooltipContent = tooltip.querySelector(
                ".tooltip__content p"
              );
              if (
                e.target != tooltipContent &&
                e.target != tooltipContent.querySelector("a")
              ) {
                e.preventDefault();
                e.stopPropagation();
                if (!tooltip.classList.contains("open")) {
                  toolTipsList.forEach(tooltip => {
                    tooltip.classList.remove("open");
                  });
                  tooltip.classList.add("open");
                  if (container) {
                    container.classList.add("tooltip_opened");
                  }
                } else if (tooltip.classList.contains("open")) {
                  tooltip.classList.remove("open");
                  if (container) {
                    container.classList.remove("tooltip_opened");
                  }
                }
              }
            }
          });
        });
        window.addEventListener("touchstart", e => {
          if (window.matchMedia("(max-width: 1024px)").matches) {
            toolTipsList.forEach(tooltip => {
              const tooltipContent = tooltip.querySelector(
                ".tooltip__content p"
              );
              if (e.target != tooltipContent) {
                if (tooltip.classList.contains("open")) {
                  if (e.target.id == "consentGeneral") {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                  } else {
                    tooltip.classList.remove("open");
                  }
                }
              }
            });
          }
        });
      }
    }
  };
}
  export default toolTips;
  